/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonArticle,
    JsonArticleFromJSON,
    JsonArticleFromJSONTyped,
    JsonArticleToJSON,
} from './JsonArticle';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonArticle
 */
export interface ApiResultOfListOfJsonArticle {
    /**
     * 
     * @type {Array<JsonArticle>}
     * @memberof ApiResultOfListOfJsonArticle
     */
    data?: Array<JsonArticle>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticle
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonArticle
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticle
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonArticle
     */
    result?: ApiResultOfListOfJsonArticleResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonArticleResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonArticleFromJSON(json: any): ApiResultOfListOfJsonArticle {
    return ApiResultOfListOfJsonArticleFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonArticle {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonArticleFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonArticleToJSON(value?: ApiResultOfListOfJsonArticle | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonArticleToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

